<template>
<div class="container">
    <div style="height: 10px"></div>
    <!--促销描述-->
    <!-- <div class="margin-sm text-sm text-333">
        <div class="acti-title">感恩有礼  豪礼回馈</div>
        <div class="acti-subtitle">请兑换您的海尔感恩月礼品</div>
    </div> -->
    <div class="imgtitle">
      <div class="leftbox">
              <div class="lsti">实物券</div>
              <div class="ls">活动实物</div>
      </div>
      <div class="rightbox">
       <div>兑换完成请登录我的-积分商城-我的订单，查看跟踪订单状态</div>
      </div>
    </div>
    <div class="cuxiao">
        <img src="../../assets/images/cuxiao.png" alt=""><span>以下商品可使用此卡劵</span>
    </div>
    <!--商品列表-->
        <productItem :productList="productList" :cardNo="cardNo" :applyCode="applyCode" :isList="isList" :isPromotion="promotionId ? true : false"></productItem>
        <div v-if="productList.length <= 0">
            <notData title="暂无相关商品" content="每天都给自己一个惊喜，看看其他商品吧" :img="notImg"></notData>
        </div>

    <!-- 回到顶部 -->
    <!-- <van-icon name="back-top" class="backtop" @click="backTop(50)" v-show="toTop"/> -->
</div>
</template>

<script>
import wx from "weixin-js-sdk";
import productItem from "@/components/product/productItem2.vue";
import notData from "@/components/notData.vue";
import {
    provideCardGoodList,
} from "../../api/api";
export default {
    components: {
        productItem,
        notData,
    },
    data() {
        return {
            cartNum: "",
            notImg: require("../../../static/images/product/not-product.png"),
            promotionId: "", //是否是促销聚合页
            polymericInfo: [], //促销聚合描述
            searchKey: this.$route.query.cName, //搜索关键词
            saleNumFlag: false,
            isList: true, //是否以列表展示  | 列表或大图
            drawer: false,
            selectedName: "综合",
            productList: [],
            arr: [],
            cName: "", //分类名称
            brandName: "", //品牌名称
            categoryName: this.$route.query.name, //分类
            chineseName: "", //商品名称
            toTop:false, //是否显示回到顶部
            menuList:[],
            cardNo:'',
            applyCode:''
        };
    },
    mounted: function (options) {
        this.applyCode = this.$route.query.applyCode
        this.cardNo = this.$route.query.cardNo
        this.classification()

    },
    methods: {

        //商品分类列表
        async classification() {
            let params={
                cardNo:this.cardNo,
                applyCode:this.applyCode
            }
            let productRes = await provideCardGoodList(params);//请求查询

            if (productRes.code == "0000") {
                this.productList = productRes.data.list;//拼接查询结果
            }
        },
    },
};
  
</script>

<style lang="scss" scoped>
.product-cart {
    position: fixed;
    right: 10px;
    bottom: 200px;
    width: 90px;
    height: 90px;
    background: $theme-color-main;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 70px;
        height: 70px;
        margin-right: 8px;
    }

    .cart-num {
        background: #ffffff;
        color: $theme-color-main;
        border-radius: 20px;
        padding: 2px 8px;
        font-size: 10px;
        position: absolute;
        right: 10px;
        top: 15px;
    }
}

/deep/.custom-image {
    width: 240px;
    height: 220px;
}

// .container {
//     background-color: #f1f1f1;
// }

.bg-white {
    background: #ffffff;
}

.coupon-icon {
    width: 62px;
    height: 28px;
    margin-right: 10px;
}

.tui-header-box {
    width: 100%;
    background: #fff;
    // position: fixed;
    // z-index: 99998;
    // left: 0;
    // top: 0px;
    padding-top: 10px;
}

.tui-searchbox {
    width: 95%;
    height: 68px;
    border: 2px solid #cbcbcb;
    border-radius: 34px;
    font-size: 28px;
    color: #cbcbcb;
    line-height: 68px;
    padding: 0px 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin: 20px;
}

.tui-search-text {
    padding-left: 16px;
}

.tui-search-key {
    /*padding:  20px;*/
    margin-left: 12px;
    display: flex;
    align-items: center;
    /*border-radius: 15px;*/
    /*background: rgba(0, 0, 0, 0.5);*/
    /*color: #fff;*/
}

.tui-key-text {
    box-sizing: border-box;
    padding-right: 12px;
    font-size: 28px;
    line-height: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
}

/*screen*/

.tui-header-screen {
    width: 100%;
    box-sizing: border-box;
    background: #fff;
}

.tui-screen-top,
.tui-screen-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 28px;
    color: #333;
}

.tui-screen-top {
    height: 88px;
    position: relative;
    background: #fff;
}

.tui-top-item {
    height: 28px;
    line-height: 28px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tui-top-item span {
    margin-right: 10px;
    padding-bottom: 8px;
}

.tui-active {
    color: $theme-color-main;
    border-bottom: 4px solid $theme-color-main;
}

.tui-attr-item.checked {
    background-color: #fff !important;
    color: $theme-color-main;
    font-weight: bold;
    position: relative;
}

.tui-attr-item.checked::after {
    content: "";
    position: absolute;
    border: 2px solid $theme-color-main;
    width: 100%;
    height: 100%;
    border-radius: 40px;
    left: 0;
    top: 0;
}

.tui-drawer-box {
    width: 636px;
    font-size: 24px;
    padding-top: 20px;
}

.tui-drawer-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    height: 80px;
    // border-bottom: 1px solid #ececec;
    margin-left: 20px;
    margin-top: 20px;
}

.tui-title-bold {
    font-size: 28px;
    font-weight: bold;
    flex-shrink: 0;
}

.tui-location {
    margin-right: 6px;
}

.tui-attr-right {
    width: 70%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: right;
}

.tui-all-box {
    width: 90%;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.tui-drawer-content {
    padding: 22px 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
}
.popup-back{
     padding: 22px 22px;
    border-bottom: 2px #ececec solid;
    font-size: 28px;

     .popback{
         color: $theme-color-main;
     }
     .poptitle{
         text-align: center;
         display: inline-block;
         width: 80%;
     }
}
.tui-flex-bottom {
    border-bottom: 30px #ececec solid;
}

.tui-input {
    border: 0;
    width: 250px;
    height: 70px;
    border-radius: 4px;
    background-color: #f7f7f7;
    text-align: center;
    font-size: 24px;
    color: #333;
}

.tui-phcolor {
    text-align: center;
    color: #b2b2b2;
    font-size: 24px;
}

.tui-flex-attr {
    flex-wrap: wrap;
    justify-content: flex-start;
}

px {
    width: 30%;
    height: 64px;
    background-color: #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 4px;
    box-sizing: border-box;
    border-radius: 32px;
    margin-right: 5%;
    margin-bottom: 5%;
}

.tui-attr-ellipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.tui-attr-btnbox {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    box-sizing: border-box;
    padding: 0 1%;
    background: #fff;
}

.tui-attr-safearea {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.tui-attr-btnbox::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    border-top: 1px solid #eaeef1;
    transform: scaleY(0.5) translateZ(0);
    transform-origin: 0 0;
}

.tui-drawer-btn {
    width: 50%;
    height: 80px;
    font-size: 30px;
    text-align: center;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.tui-drawerbtn-black{
    border: 1px solid $theme-color-main;
    color:$theme-color-main
}
.tui-drawerbtn-primary {
    background: $theme-color-main;
    color: #fff;
}

.icon-pailie {
    width: 34px;
    height: 34px;
}

.icon-active {
    width: 20px;
    height: 10px;
}

.tui-attr-item {
    margin-right: 16px;
    margin-bottom: 30px;
    width: 180px;
    height: 68px;
    background: #f1f1f1;
    border-radius: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    // color: #111;
    font-size: 25px;
}

.middle {
    width: 20px;
    height: 1px;
    background: #dbdbdb;
}

.acti-title{
  font-size: 34px;
  font-weight: bold;
  text-align:center;
  margin-bottom: 10px;
}
.acti-subtitle{
  font-size: 28px;
  text-align:center;
  margin-bottom: 10px;
}
.imgtitle{
    height: 3rem;
    text-align: center;
    display: flex;
    margin: 10px auto;
    width: 90%;

    .leftbox{
        background: url("../../assets/images/coupon_left.png") no-repeat;
        background-size: contain;
        width: 3.6rem;
        position: relative;
        color:#fff;
        .ls{
            margin:1rem auto;
            font-size: 1.4em;
            font-weight: 600;
            
        }
        .lsti{
                position: absolute;
                border-radius: 50px;
                padding: 2px 10px;
                top: 8px;
                font-size: .9em;
                border-bottom-left-radius: 0;
                background: -webkit-linear-gradient(right,#a555f6, #427dee); 
                background: linear-gradient(to right,#a555f6, #427dee); 


            }
    }
    .rightbox{
        background: url("../../assets/images/coupon_right.png") no-repeat ;
        background-size: contain;
        text-align: left;
        line-height: 2em;
        div{
            margin:.6rem auto;
            width: 80%;
        }
    }
}

.cuxiao{
    border-top: 2px solid #EDEDED ;
    padding:20px;
    padding-left: 30px;
    img{
        width: 30px;
        vertical-align: sub;
        margin-right: 10px;
    }
}
</style>
